module.exports = __webpack_public_path__ + "img/bee.1a79db54.svg";